module.exports = __webpack_public_path__ + "media/icons/clip-5bdbc313.png";